import React, { useEffect, useState } from 'react';
import Page from '../../layout/Page/Page';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import { dashboardMenu } from '../../menu';
import UserService from '../../http/services/UserService';

interface ITransaction {
    id: number;
    userId: number;
    gatewayTransactionId: string;
    gatewaySubscriptionId: string;
    createdAt: string;
}

const PaymentHistoryPage = () => {
    const [transactions, setTransactions] = useState<ITransaction[] | null>(null);
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        UserService.getTransactions()
            .then(res => {
                console.log('✅ Ответ от бэка:', res);
                setTransactions(res.data);
            })
            .catch(err => {
                console.error('❌ Ошибка при получении транзакций:', err);
                setError(err);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <PageWrapper title={dashboardMenu.history.text}>
            <Page>
                <h1>История платежей</h1>
                {loading && <p>Загрузка...</p>}
                {error && <pre style={{ color: 'red' }}>{JSON.stringify(error, null, 2)}</pre>}
                {transactions && transactions.length > 0 ? (
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#eee' }}>
                                <th style={{ padding: '8px', border: '1px solid #ccc' }}>ID транзакции</th>
                                <th style={{ padding: '8px', border: '1px solid #ccc' }}>ID подписки</th>
                                <th style={{ padding: '8px', border: '1px solid #ccc' }}>Дата платежа</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transactions.map(tx => (
                                <tr key={tx.id}>
                                    <td style={{ padding: '8px', border: '1px solid #ccc' }}>{tx.gatewayTransactionId}</td>
                                    <td style={{ padding: '8px', border: '1px solid #ccc' }}>{tx.gatewaySubscriptionId}</td>
                                    <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                                        {new Date(tx.createdAt).toLocaleDateString()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    !loading && <p>История платежей пуста.</p>
                )}
            </Page>
        </PageWrapper>
    );
};

export default PaymentHistoryPage;
